import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarPopupShell = _resolveComponent("AvatarPopupShell")!
  const _component_AuthManager = _resolveComponent("AuthManager")!
  const _component_ConfigManager = _resolveComponent("ConfigManager")!
  const _component_ConnectionManager = _resolveComponent("ConnectionManager")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["module-app", { 'avatar-popup-root': _ctx.isAvatarPopup }])
  }, [
    (_ctx.isAvatarPopup)
      ? (_openBlock(), _createBlock(_component_AvatarPopupShell, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_AuthManager, {
                key: 0,
                onAuthSuccess: _ctx.handleAuthSuccess
              }, null, 8, ["onAuthSuccess"]))
            : (_ctx.isAuthenticated && !_ctx.configLoaded)
              ? (_openBlock(), _createBlock(_component_ConfigManager, {
                  key: 1,
                  onConfigLoaded: _ctx.handleConfigLoaded
                }, null, 8, ["onConfigLoaded"]))
              : (_openBlock(), _createBlock(_component_ConnectionManager, {
                  key: _ctx.moduleKey,
                  config: _ctx.connectionConfig,
                  onGoBack: _ctx.handleLogout
                }, null, 8, ["config", "onGoBack"]))
        ], 64))
  ], 2))
}